// autogenerated by channel_search/generate.py -- do not edit
import { DeviceNodeHealth } from "@skydio/pbtypes/pbtypes/gen/flight_connect/device_node_health_pb";
export { DeviceNodeHealth };

export const DEVICE_NODE_HEALTH_SUMMARY_PB = {
  channel: "DEVICE_NODE_HEALTH_SUMMARY_PB",
  type: DeviceNodeHealth.deserializeBinary
};
